import { NgModule } from '@angular/core'
import { DetectIosSafariFullscreenDirective } from './detect-ios-safari-fullscreen.directive'

// prettier-ignore
@NgModule({
  declarations: [DetectIosSafariFullscreenDirective],
  exports: [DetectIosSafariFullscreenDirective]
})
export class FullscreenDetectorModule {}
